export const getMesMaisRecente = (meses) => {
  if (!meses?.length) return null;

  const mesesMap = {
    jan: 0, fev: 1, mar: 2, abr: 3, mai: 4, jun: 5,
    jul: 6, ago: 7, set: 8, out: 9, nov: 10, dez: 11,
  };

  const parseMes = (mesStr) => {
    const [mesAbrev, anoStr] = mesStr.toLowerCase().split("/");
    return new Date(2000 + +anoStr, mesesMap[mesAbrev] ?? 0, 1);
  };

  return meses.reduce((maisRecente, atual) =>
    parseMes(atual.mes) > parseMes(maisRecente.mes) ? atual : maisRecente
  );
}

const normalizarTipo = (tipo) => String(tipo || "").trim().toLowerCase();

export const isTipoReflex = (tipo) => normalizarTipo(tipo).startsWith("reflex");
export const isTipoCampanha = (tipo) => normalizarTipo(tipo).startsWith("campanha");

const getChaveIndicador = (item) => (
  `${normalizarTipo(item?.tipo)}|${normalizarTipo(item?.kpi)}`
);

export const removerDuplicadosPriorizandoPleito = (items = []) => {
  const porIndicador = new Map();

  for (const item of items) {
    const chave = getChaveIndicador(item);
    const atual = porIndicador.get(chave);

    if (!atual || (item?.pleito === true && atual?.pleito !== true)) {
      porIndicador.set(chave, item);
    }
  }

  return [...porIndicador.values()];
};

const toFiniteNumber = (value) => {
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
};

export const getDirecaoMetas = (metas = {}) => {
  const m100 = toFiniteNumber(metas?.m100);
  const m300 = toFiniteNumber(metas?.m300);
  const m500 = toFiniteNumber(metas?.m500);

  if (m100 === null || m300 === null || m500 === null) return "ascending";
  if (m100 > m300 && m300 > m500) return "descending";
  if (m100 < m300 && m300 < m500) return "ascending";

  return "ascending";
};

export const atingiuMeta = ({ valor, meta, direcao, inclusive = true }) => {
  const valorNum = toFiniteNumber(valor);
  const metaNum = toFiniteNumber(meta);

  if (valorNum === null || metaNum === null) return false;

  if (direcao === "descending") {
    return inclusive ? valorNum <= metaNum : valorNum < metaNum;
  }

  return inclusive ? valorNum >= metaNum : valorNum > metaNum;
};

const shouldIncludeM700 = (metas = {}, direcao) => {
  const m500 = toFiniteNumber(metas?.m500);
  const m700 = toFiniteNumber(metas?.m700);

  if (m500 === null || m700 === null) return false;

  if (direcao === "descending") return m700 < m500;

  return m700 > m500;
};

export const getMetaAtingida = ({ valor, metas = {}, includeM700 = false }) => {
  const direcao = getDirecaoMetas(metas);
  const orderedMetas = [];

  if (includeM700 && shouldIncludeM700(metas, direcao)) {
    orderedMetas.push("m700");
  }

  orderedMetas.push("m500", "m300", "m100");

  for (const metaKey of orderedMetas) {
    if (atingiuMeta({ valor, meta: metas?.[metaKey], direcao })) {
      return metaKey;
    }
  }

  return null;
};

export const isIndicadorGatilhoNaoAtingido = (item) => {
  if (!item?.gatilho || !isTipoReflex(item?.tipo)) return false;

  const volume = Number(item?.volumes?.realAjustado ?? item?.volumes?.real ?? 0);
  const meta = Number(item?.metas?.m100);
  const direcao = getDirecaoMetas(item?.metas);

  if (!Number.isFinite(meta)) return false;

  return !atingiuMeta({ valor: volume, meta, direcao });
};

export const temGatilhoNaoAtingido = (itens = []) =>
  itens.some((item) => isIndicadorGatilhoNaoAtingido(item));

export const isIndicadorGatilhoAtivo = (item) => (
  Number(item?.gatilho) === 1 && isTipoReflex(item?.tipo)
);

export const getBackgroundColor = (item) => {

  if (
    typeof item.tipo === "string" &&
    isTipoCampanha(item.tipo)
  ) {
    return "#F5C115";
  }
  if (isIndicadorGatilhoAtivo(item)) return "#E4532E";

  return "#01054C";
};





export const monthMap = {
  jan: "Janeiro",
  fev: "Fevereiro",
  mar: "Março",
  abr: "Abril",
  mai: "Maio",
  jun: "Junho",
  jul: "Julho",
  ago: "Agosto",
  set: "Setembro",
  out: "Outubro",
  nov: "Novembro",
  dez: "Dezembro",
};

export function getCurrentQuarterMonths() {
  const now = new Date();
  const month = now.getMonth();
  const year = now.getFullYear();


  const startMonth = Math.floor(month / 3) * 3;
  const monthsInQuarter = [startMonth, startMonth + 1, startMonth + 2];

  const abbrev = [
    "jan", "fev", "mar", "abr", "mai", "jun",
    "jul", "ago", "set", "out", "nov", "dez"
  ];

  return monthsInQuarter.map(
    (m) => `${abbrev[m]}/${String(year).slice(2)}`
  );
}




export function obterMesesMaisRecentes(vendedorSelecionado, vendedores) {
  const mesesMap = {
    jan: "Janeiro", fev: "Fevereiro", mar: "Março", abr: "Abril",
    mai: "Maio", jun: "Junho", jul: "Julho", ago: "Agosto",
    set: "Setembro", out: "Outubro", nov: "Novembro", dez: "Dezembro",
  };

  const mesesArray = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun',
                     'jul', 'ago', 'set', 'out', 'nov', 'dez'];

  function obterDataMes(mesString) {
    const [mesAbreviado, ano] = mesString.split('/');
    const mesIndex = mesesArray.indexOf(mesAbreviado);
    return new Date(2000 + Number.parseInt(ano), mesIndex);
  }

  function obterMesMaisRecenteDoVendedor(vendedor) {
    if (!vendedor?.meses?.length) return null;

    const mesMaisRecente = vendedor.meses.reduce((maisRecente, atual) =>
      obterDataMes(atual.mes) > obterDataMes(maisRecente.mes) ? atual : maisRecente
    );

    const [mesAbreviado, ano] = mesMaisRecente.mes.split('/');
    return `${mesesMap[mesAbreviado]}/${ano}`;
  }

  function obterVendedorComMesMaisRecente(vendedores) {
    if (!vendedores?.length) return null;

    return vendedores.reduce((melhorVendedor, vendedorAtual) => {
      if (!vendedorAtual.meses?.length) return melhorVendedor;

      const mesRecenteAtual = vendedorAtual.meses.reduce((maisRecente, atual) =>
        obterDataMes(atual.mes) > obterDataMes(maisRecente.mes) ? atual : maisRecente
      );

      if (!melhorVendedor) return vendedorAtual;

      const mesRecenteMelhor = melhorVendedor.meses.reduce((maisRecente, atual) =>
        obterDataMes(atual.mes) > obterDataMes(maisRecente.mes) ? atual : maisRecente
      );

      return obterDataMes(mesRecenteAtual.mes) > obterDataMes(mesRecenteMelhor.mes)
        ? vendedorAtual
        : melhorVendedor;
    }, null);
  }

  const vendedorMaisRecente = obterVendedorComMesMaisRecente(vendedores);

  return {
    vendedorSelecionado: obterMesMaisRecenteDoVendedor(vendedorSelecionado),
    vendedores: vendedorMaisRecente ? {
      id: vendedorMaisRecente.id,
      codigoVendedor: vendedorMaisRecente.codigoVendedor,
      nomeVendedor: vendedorMaisRecente.nomeVendedor,
      mesMaisRecente: obterMesMaisRecenteDoVendedor(vendedorMaisRecente)
    } : null
  };
}